import { Howl, Howler } from 'howler'

const Sounds = {
	sounds_list: {}
}

Sounds.sounds_list = {
	card: new Howl({ src: [ require('@/assets/sounds/card.mp3') ], format: ['mp3'], volume: 0.5 }),
	hit: new Howl({ src: [ require('@/assets/sounds/hit.mp3') ], format: ['mp3'], volume: 0.1 }),
	coins: new Howl({ src: [ require('@/assets/sounds/coins.mp3') ], format: ['mp3'], volume: 0.25 }),
	heal: new Howl({ src: [ require('@/assets/sounds/heal.mp3') ], format: ['mp3'], volume: 0.25 }),
	shield: new Howl({ src: [ require('@/assets/sounds/shield.mp3') ], format: ['mp3'], volume: 0.1 }),
	equip: new Howl({ src: [ require('@/assets/sounds/equip.mp3') ], format: ['mp3'], volume: 0.5 }),
	chest: new Howl({ src: [ require('@/assets/sounds/chest.mp3') ], format: ['mp3'], volume: 0.5 }),
	'deal-card': new Howl({ src: [ require('@/assets/sounds/deal-card.mp3') ], format: ['mp3'], volume: 0.25 }),
	lose: new Howl({ src: [ require('@/assets/sounds/lose.mp3') ], format: ['mp3'], volume: 0.25 }),
	win: new Howl({ src: [ require('@/assets/sounds/win.mp3') ], format: ['mp3'], volume: 0.25 }),
}

Sounds.play = function(name) {
	if (name) Sounds.sounds_list[name].play()
},

Sounds.stop = function(name) {
	if (name) Sounds.sounds_list[name].stop()
},

Sounds.mute = function(active) {
	for (var i in Sounds.sounds_list) {
		Sounds.sounds_list[i].mute(active)
	}
}

export default Sounds